import { ArticlePath, createGuideLink, TextKey } from '@mews-commander/enums';
import { DialogProvider } from '@mews-commander/ui';
import { EnterpriseType, UserType } from '../types';
import { UsersContextProvider } from '../context';
import { UserDetailContextProvider } from '../context/userDetailContext';
import { Users } from '../components/UsersList';

export const PropertyLayout = ({ userType }: { userType: UserType }) => {
    const guideLink = createGuideLink(ArticlePath.CreateDeleteEmployeeProfile);

    return (
        <UsersContextProvider userType={userType} enterpriseType={EnterpriseType.Property}>
            <UserDetailContextProvider>
                <DialogProvider>
                    <Users
                        guideLink={guideLink}
                        activeTab={
                            userType === UserType.Portfolio ? TextKey.PortfolioUserPlural : TextKey.PropertyUsers
                        }
                    />
                </DialogProvider>
            </UserDetailContextProvider>
        </UsersContextProvider>
    );
};
